import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReviewersStatisticsGridItem from './ReviewersStatisticsGridItem';
import axiosClient from '../../../../axios-client'


export default function ReviewersStatisticsGrid({ chartData }) {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    axiosClient.get(`/reviews/countReviewers`)
      .then(response => {
        setTotal(response.data.total_reviewers);
      })
      .catch(error => {
      });
  }, []);
  return (
    <>
      <div className="p-2 bg-white border-2 border-muted-500 rounded-xl">
        <h2 className="text-base font-medium">إجمالي المقيمين: 
          <span className="mr-2 text-2xl text-succes-700 font-semibold">
            {total}
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-2">
        {chartData.map((data, index) => (
          <ReviewersStatisticsGridItem key={index} data={data} />
        ))}
      </div>
    </>
  );
}
